module.exports = __webpack_public_path__ + "img/icon-business-receive-02.svg";